import groq from "groq"

export const groqArticleProjection = () => groq`
    "id":_id,
    articleInfo,
    articleMainGroup -> { "id": _id, name, key},
    articleGroup -> { "id": _id, name, key},
    supplier -> { "id": _id, "name": name1, name2, name3, supplierNr, notes},
    notAvailableInBranchOffices[]->{
        ...,
        deliveryAddress {
            "name": name1,
            "nameAddition": name2,
            "city": place,
            "zipCode": zip,
            poBox,
            country,

        },
        billingAddress {
            "name": name1,
            "nameAddition": name2,
            "city": place,
            "zipCode": zip,
            poBox,
            country,

        }
    },
    "attributes": attributeValues[] {
        attribute-> {
            id,
            key,
            type,
        },
        value
    },
    "productRef": *[_type=="product" && references(^._id)][0] {
        _id,
        title,
        key,
        title,
        category,
        hidden,
        mix,
        sale,
        "images": attachments[type=="img"] {...,asset->},
        "technicalManuals":attachments[type=="tm"] {...,asset->},
        "sdbManuals":attachments[type=="sdb"] {...,asset->},
        "zertManuals":attachments[type=="zert"] {...,asset->},
        "attributes": attributeValues[] {
            attribute-> {
                id,
                key,
                type,
            },
            value
        },
    }
`
export const groqShortArticleProjection = () => groq`
    notAvailableInBranchOffices[]->{
        ...,
        deliveryAddress {
            "name": name1,
            "nameAddition": name2,
            "city": place,
            "zipCode": zip,
            poBox,
            country,

        },
        billingAddress {
            "name": name1,
            "nameAddition": name2,
            "city": place,
            "zipCode": zip,
            poBox,
            country,

        }
    },
    "id":_id,
    "attributes": attribute[]->{
        id,
        key,
        type,
        value
    },
`
